import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Connects to data-controller='top'
export default class extends Controller {
  static targets = ['form']

  connect() {
    this.initializeSwiper()
  }

  submit() {
    this.formTarget.submit()
  }

  initializeSwiper() {
    let swiperInstance;

    // 古いインスタンスがあれば破棄する
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
    }

    // Swiperを再初期化
    swiperInstance = new Swiper(".swiper", {
      loop: true,
      slidesPerView: 'auto',
      speed: 30000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
    });
  }
}
